/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  SvgIcon
} from "../"

// TODO: requires SLDS version 2.4.1

export const ProgressRing = (props) => {
  let isLong = props.fillPercentage > 50 ? '1' : '0'
  let arcX = Math.cos(2 * Math.PI * props.fillPercentage)
  let arcY = Math.sin(2 * Math.PI * props.fillPercentage)

  return (
    <div className="slds-progress-ring">
      <div
        className="slds-progress-ring__progress"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow={props.fillPercentage}>
        <svg viewBox="-1 -1 2 2">
          <path
            className="slds-progress-ring__path"
            id="slds-progress-ring-path"
            d={`M 1 0 A 1 1 0 ${isLong} 1 ${arcX} ${arcY} L 0 0`} />
        </svg>
      </div>
      <div className="slds-progress-ring__content">
        {/* TODO: icon or text */}
        <SvgIcon
          variant="utility"
          symbol="check"
        />
      </div>
    </div>
  )
}

ProgressRing.propTypes = {
  fillPercentage: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/components/progress-ring/index.js